<template>
  <div class="portlet">
    <div v-if="hasTitle" class="portlet-header border-bottom mb-1 text-left" :class="manageHeaderClass">
      <span class="d-block text-truncate font-weight-medium" :class="manageHeaderTextClass">
        {{ getTitle() }}
        <a class="btn btn-sm btn-success btn-soft float-end" data-toggle="collapse"
           :href="'#'+collapseId" role="button" aria-expanded="false"
           aria-controls="collapseExample2" v-if="collapsible">
            <span>+/-</span>
            <span class="group-icon">
                <i class="fi fi-arrow-end-slim"></i>
                <i class="fi fi-arrow-down-slim"></i>
            </span>
        </a>
      </span>

    </div>

    <div class="portlet-body pb-0" :class="collapsed?'collapse':'collapse show'" :id="collapseId">
      <div class="collapse show" c-collapse-list>
        <div >
          <div >
            <div c-search-container>
            </div>
            <div c-list-container>

            </div>

          </div>
        </div>
      </div>

      <div class="collapse" c-collapse-edit>
        <div class="portlet">

          <!-- portlet : header -->
          <div class="portlet-header border-bottom mb-3" :class="$crud.env.layoutGradientColor">
            <span class="d-block text-white text-truncate font-weight-medium" v-show="updateTitle">
              {{updateTitle}}
            </span>
          </div>
          <!-- /portlet : header -->

          <div class="portlet-body pb-0" c-edit-container>

          </div>
        </div>
      </div>
    </div>

    <div c-view_dialog class="modal" tabindex="-1" role="dialog"
         aria-labelledby="" aria-hidden="true"
    >
      <div class="modal-dialog modal-lg"  role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{viewTitle}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="fi fi-close fs--18" aria-hidden="true"></span>
            </button>
          </div>
          <div c-view-container class="modal-body">

          </div>
          <div class="modal-footer">
            <button crud-button="ok" type="button" class="btn btn-outline-success"
                    data-dismiss="modal">
              <i class="fi fi-check"></i>
              OK
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>

import cComponent from '../misc/cComponent'
import { crud, cManageMixin } from 'crud-vue-core'

crud.conf['c-manage'].collapsible = false
crud.conf['c-manage'].collapsed = false
crud.conf['c-manage'].collapseId = null

crud.conf['c-manage'].listSelector = '[c-list-container]';
crud.conf['c-manage'].searchSelector = '[c-search-container]';
crud.conf['c-manage'].updateAreaSelector = '[c-collapse-edit]';
crud.conf['c-manage'].listAreaSelector = '[c-collapse-list]';
crud.conf['c-manage'].updateSelector = '[c-edit-container]';
crud.conf['c-manage'].viewSelector = '[c-view-container]';


export default {
  name: 'c-manage',
  extends: cComponent,
  // props: ['cModel', 'cInlineEdit', 'cCollapsible'],
  mixins: [cManageMixin],
  methods: {
    _dynamicData (conf) {
      conf.collapseId = 'manageCollapse' + conf.modelName
      console.log('cmanage dynamic data',conf);
      return conf
    },
      showEdit() {
        console.log('cManage.showEdit',this.editComp);
          this.jQe(this.updateAreaSelector).collapse('show');
          this.jQe(this.listAreaSelector).collapse('hide');
      },

      showList() {
          this.jQe(this.updateAreaSelector).collapse('hide');
          this.jQe(this.listAreaSelector).collapse('show');
          this.jQe(this.updateSelector).html(' ');
      },
      showInsert() {
          this.jQe(this.updateAreaSelector).collapse('show');
          this.jQe(this.listAreaSelector).collapse('hide');
      },
      getTitle() {
        return this.translate('app.gestione') + ' ' + this.translate(this.modelName + '.label', 1);
      }
  }
}
</script>

<style scoped>

</style>
